<template>
  <div class="d-grid" style="grid-template-columns: auto 1fr">
    <div class="badge" :class="{ [status_badge_color]: true, 'rounded-end-0': is_running }">{{
      status_label }}</div>
    <progress v-if="is_running" class="progress rounded-start-0 h-100" :value="progress_current"
      :max="progress_total">{{ percentage }}</progress>
  </div>
</template>

<script lang="ts">
import { defineComponent, markRaw } from "vue";
import type { PropType } from "@/types";
import { ElectionAuditChannelSubscription } from "@/channels/ElectionAuditChannel";

interface ElectionAuditInitialData {
  status: string;
  status_label: string;
  progress_current: number;
  progress_total: number;
}

interface Data {
  initial_data: ElectionAuditInitialData
}

export default defineComponent({
  name: "ElectionAuditProgress",
  props: {
    election_audit_id: {
      type: Number,
      required: true,
    },
    initial_data: {
      type: Object as PropType<ElectionAuditInitialData>,
      default: () => ({}),
    },
  },
  data: ({ initial_data: { status, status_label, progress_current, progress_total } }: Data) => ({
    status,
    status_label,
    progress_current,
    progress_total,
    channelSubscription: null as ElectionAuditChannelSubscription | null,
  }),
  computed: {
    status_badge_color() {
      switch (this.status) {
        case "failed": return 'text-bg-warning';
        case "error": return 'text-bg-warning';
        case "passed": return 'text-bg-success';
        case "running": return 'text-bg-primary';
        case "unauditable": return 'text-bg-warning';
        default: return 'text-bg-dark';
      }
    },
    percentage() {
      return `${100 * this.progress_current / this.progress_total}%`;
    },
    is_running() {
      return this.status === "running";
    },
  },
  methods: {
    handleReceived({ progress_current, progress_total, status, status_label }) {
      console.debug("received election audit progress update")
      this.progress_current = progress_current;
      this.progress_total = progress_total;
      this.status = status;
      this.status_label = status_label;
    }
  },
  created() {
    // markRaw: a reactive proxy would break ActionCable's identity check on unsubscribe
    this.channelSubscription = markRaw(new ElectionAuditChannelSubscription(
      this.election_audit_id,
      {
        received: this.handleReceived,
      }));
  },
  beforeUnmount() {
    this.channelSubscription?.unsubscribe();
  },
});
</script>
